export default {
  yearly: [],
  monthly: [],
  topYear: {},
  topDay: {},
  topMonth: {},
  expiringProducts: []
};
